<template>
    <div class="card card-form">
        <!-- Toolbar -->
        <div class="card-header">
            <responsive>
                <div class="d-flex flex-nowrap">
                    <ul class="nav nav-tabs card-header-tabs mr-auto">
                        <li class="nav-item" v-for="item in options.range" :key="item.value">
                            <span class="nav-link" :class="{'active': filter.range == item.value}" @click="filter.range = item.value; filterData();">{{ $t(item.text) }}</span>
                        </li>
                    </ul>
                    <div class="btn-toolbar ml-3">
                        <button class="btn btn-primary d-lg-none" @click="filter.visible = !filter.visible">
                            <i class="fas fa-fw fa-filter" v-if="!filter.visible"></i>
                            <i class="fas fa-fw fa-times" v-if="filter.visible"></i>
                        </button>
                        <button class="btn btn-primary" @click="filterData()">
                            {{ $t('[[[Filtruj]]]') }}
                        </button>
                        <button class="btn btn-secondary" @click="resetFilter()">
                            {{ $t('[[[Resetuj]]]') }}
                        </button>
                    </div>
                </div>
            </responsive>
        </div>
        <div class="row no-gutters">
            <!-- Filtry -->
            <div class="sidebar col-lg-3 order-lg-last p-3" :class="{'d-none d-lg-block': !filter.visible}">
                <b-form-group :label="$t('[[[Imię]]]')" :feedback="filter.$errors.first('givenName')" :state="filter.$errors.state('givenName')">
                    <b-form-input v-model="filter.givenName" type="text" name="givenName"></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('[[[Nazwisko]]]')" :feedback="filter.$errors.first('surname')" :state="filter.$errors.state('surname')">
                    <b-form-input v-model="filter.surname" type="text" name="surname"></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('[[[Email]]]')" :feedback="filter.$errors.first('email')" :state="filter.$errors.state('email')">
                    <b-form-input v-model="filter.email" type="text" name="email"></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('[[[Aktywny]]]')" :feedback="filter.$errors.first('isActive')" :state="filter.$errors.state('isActive')">
                    <b-form-select v-model="filter.isActive" type="select">
                        <option v-for="item in test" :key="item.text" :value="item.value">{{$t(item.text)}}</option>
                    </b-form-select>
                </b-form-group>
            </div>
            <!-- Tabela -->
            <div class="col-lg-9 p-3">
                <responsive>
                    <table class="table table-data table-striped table-hover">
                        <colgroup>
                            <col>
                            <col>
                            <col>
                            <col style="width:160px">
                            <col>
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th class="text-nowrap">{{ $t('[[[Id]]]') }}</th>
                                <th class="text-nowrap">{{ $t('[[[Nazwisko]]]') }}</th>
                                <th class="text-nowrap">{{ $t('[[[Imię]]]') }}</th>
                                <th class="text-nowrap">{{ $t('[[[Email]]]') }}</th>
                                <th class="text-nowrap">{{ $t('[[[Aktywny]]]') }}</th>
                                <th class="buttons"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td class="img">
                                    <b-img :src="item.facePictureUrl | image('ico')" rounded="circle" :blank="!item.facePictureUrl" width="36" height="36" blank-color="#777" :alt="$t('[[[Zdjęcie użytkownika]]]')" />
                                </td>
                                <td class="text-nowrap">
                                    <b-link :to="{name:'core-users-edit', params: { id: item.id }}">{{item.id}}</b-link>
                                </td>
                                <td class="text-nowrap">{{item.surname}}</td>
                                <td class="text-nowrap">{{item.givenName}}</td>
                                <td class="text-nowrap">{{item.email}}</td>
                                <td class="text-nowrap">{{item.isActive ? $t('[[[Tak]]]') : $t('[[[Nie]]]')}}</td>
                                <td class="buttons">
                                    <b-button-group size="sm">
                                        <b-button v-if="item.isAnonymised === false" variant="outline-primary" :to="{name:'core-users-edit', params: { id: item.id }}" :title="$t('[[[Edytuj]]]')">
                                            <i class="fas fa-pencil-alt"></i>
                                        </b-button>
                                        <b-button v-else variant="outline-info" :to="{name:'core-users-edit', params: { id: item.id }}" :title="$t('[[[Przeglądnij dane]]]')">
                                            <i class="fas fa-file-alt"></i>
                                        </b-button>
                                        <b-button variant="outline-danger" :id="`btn-anonymise-${item.id}`" :title="$t('[[[Anonimizuj]]]')" :disabled="!item.meta.canAnonymise">
                                            <i class="fas fa-folder-minus"></i>
                                        </b-button>
                                    </b-button-group>
                                    <confirmation :message="$t('[[[Zanonimizować i dezaktywować konto użytkownika]]]' + '?')" :target="`btn-anonymise-${item.id}`" :value="item" @confirm="anonymiseItem" />
                                </td>
                            </tr>
                            <tr v-if="items.length == 0">
                                <td colspan="6" class="text-center">{{ $t('[[[Brak danych.]]]') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </responsive>
            </div>
        </div>
        <!-- Przyciski -->
        <div class="card-footer">
            <responsive>
                <div class="d-flex flex-nowrap">
                    <router-link class="btn btn-primary mr-3" :to="{name:'core-users-add'}" :disabled="!meta.canCreate">
                        <i class="fas fa-fw fa-plus"></i> {{ $t('[[[Dodaj użytkownika]]]') }}
                    </router-link>
                    <pagination :pager="pager" @change="filterData()" class="mx-auto"></pagination>
                    <select v-model="pager.pageSize" @change="filterData()" class="form-control w-auto ml-3">
                        <option v-for="item in [10, 20, 50, 100]" :key="item" :value="item">{{item}}</option>
                    </select>
                </div>
            </responsive>
        </div>
    </div>
</template>

<script>
import UsersService from '@/services/core/UsersService';

export default
{
    data: function()
    {
        return {
            options: {
                range: [
                    { value: 'all', text: '[[[Wszyscy]]]' },
                    { value: 'admin', text: '[[[Administratorzy]]]' },
                    { value: 'inactive', text: '[[[Niepotwierdzeni]]]' }
                ]
            },
            test: [
                { value: null, text: '[[[Wszyscy]]]' },
                { value: true, text: '[[[Tak]]]' },
                { value: false, text: '[[[Nie]]]' }
            ],
            items: [],
            meta: {}
        };
    },

    store: {
        filter: 'modules.core.users.filter',
        pager: 'modules.core.users.pager'
    },

    created: function()
    {
        this.loadData();
    },

    methods: {
        async loadData()
        {
            try
            {
                let response = await UsersService.getList(this.filter, this.pager);
                this.pager.setTotalRows(response.data.totalRows);
                this.items = response.data.items;
                this.meta = response.data.meta;
            }
            catch (ex)
            {
                this.pager.setTotalRows(0);
                this.items = [];
                this.$log.debug(ex);
            }
        },

        async anonymiseItem(item)
        {
            try
            {
                if (this.$auth.user().id === item.id)
                {
                    this.abort(400, this.$t('[[[Nie można zanonimizować swojego konta.]]]'));
                }

                await UsersService.anonymise(item.id);
                this.$alert.success(this.$t('[[[Użytkownik został zanonimizowany.]]]'));
                await this.loadData();
            }
            catch (ex)
            {
                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                this.$log.debug(ex);
            }
        },

        async filterData()
        {
            await this.loadData();
        },

        async resetFilter()
        {
            this.filter.reset();
            await this.loadData();
        }
    }
};
</script>
